import * as React from 'react';
import './Spinner.scss';

type SpinnerVariant = 'default' | 'hud' | 'dark-bg';

interface Props {
  variant?: SpinnerVariant,
  wrap?: 'center'
}

export default function renderSpinner(props: Props): React.ReactElement<Props> {
  const variant = validateVariant(props.variant);
  const src = require(
    `images/ajax-loader-${variant}.gif`
  ).default;

  const classes = `spinner spinner--${variant}`;
  const spinner = <img className={classes} src={src} />;

  if (props.wrap) {
    return <div className="spinner__wrap--center">{spinner}</div>;
  } else {
    return spinner;
  }
}

function validateVariant(v: string | undefined): SpinnerVariant {
  switch(v) {
    case 'hud':
    case 'dark-bg':
      return v
    default:
      return 'default'
  }
}
